import React, { useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Typography } from '@material-ui/core';
import { authenticationService } from '../../services';

export default function LoginHandler(props) {
  const history = useHistory();

  const { action = 'login' } = props;

  const login = useCallback(async () => {
    const state = {
      returnUrl: "/dashboard"
    };

    await authenticationService.signIn(state);
  }, []);

  const completeLogin = useCallback(async () => {
    const url = window.location.href;
    const response = await authenticationService.signInCallback(url);

    switch (response.status) {
      case "success":
        history.replace(response.state.returnUrl);
        break;
      case "error":
        console.log(response.message);
        break;
      default:
        console.log("Invalid authentication result.");
        break;
    };
  }, [history]);

  const logout = useCallback(async () => {
    const state = {
      returnUrl: "/login"
    };

    await authenticationService.signOut(state);
  }, []);

  const completeLogout = useCallback(async () => {
    const url = window.location.href;
    const response = await authenticationService.signOutCallback(url);

    switch (response.status) {
      case "success":
        history.replace(response.state.returnUrl);
        break;
      case "error":
        console.log(response.message);
        break;
      default:
        console.log("Invalid authentication result.");
        break;
    };
  }, [history]);

  useEffect(() => {
    switch (action) {
      case "login":
        login();
        break;
      case "login-callback":
        completeLogin();
        break;
      case "logout":
        logout();
        break;
      case "logout-callback":
        completeLogout();
        break;
      default:
        throw new Error("Invalid action encountered by login handler.");
    };
  }, [
    action,
    login,
    logout,
    completeLogin,
    completeLogout
  ]);

  return (
    <Typography>
      Please wait ...
    </Typography>
  );
};